import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-form"
export default class extends Controller {
  static values = { turboFrame: String }

  connect() {
    // Scroll into view on connect if there are active search params
    const params = new URLSearchParams(window.location.search)
    const hasSearchQuery = Array.from(params.keys()).some(key => key.startsWith('q['))
    if (hasSearchQuery) {
      this.element.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  submit() {
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  clear(event) {
    event.preventDefault()

    // Reset all form inputs
    this.element.reset()

    // Find the target turbo frame and navigate it to the current path (no query params)
    const frameId = this.turboFrameValue || this.element.dataset.turboFrame
    const frame = document.getElementById(frameId)
    if (frame) {
      frame.src = window.location.pathname
    }

    // Scroll the form into view
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
